import { ReactNode } from "react";

import HawkeyePage from "../intelligence-briefing-library/HawkeyePage";
import AccountSynopsis from "../Pages/AccountSynopsis";
import AccountWorkspace from "../Pages/AccountWorkspace";
import AlwaysOnChannel from "../Pages/AlwaysOnChannel";
import ComingSoon from "../Pages/ComingSoon";
import CoveragePage from "../Pages/CoverageAnalysis";
import CreateAssessmentTemplate from "../Pages/CreateAssessmentTemplate";
import EasyOnboarding from "../Pages/EasyOnboarding";
import EmailActivity from "../Pages/EmailActivity";
import ExecutiveStaff from "../Pages/ExecutiveStaff";
import GuidancePlaybooks from "../Pages/GuidancePlaybooks";
import LeaderboardPage from "../Pages/Leaderboard";
import Ops from "../Pages/Ops";
import Relationship from "../Pages/Relationship";
import Settings from "../Pages/Settings";
import SponsorDrilldownPage from "../Pages/SponsorDrilldown";
import SponsorTipDetail from "../Pages/SponsorTipDetail";
import SponsorTipsLibrary from "../Pages/SponsorTipsLibrary";
import TeamViewsPage from "../Pages/TeamViews";
import TempViewsRendering from "../Pages/TempViewsRendering";
import VendorAdminHome from "../Pages/VendorAdminHome";
import XFactorBriefings from "../Pages/XFactorBriefings";

export interface VenderAdminRoute {
  path: string;
  element: ReactNode;
  label?: string;
}

const venderAdminRoutes: VenderAdminRoute[] = [
  {
    path: "/",
    element: <VendorAdminHome />,
    label: "Home",
  },
  {
    path: "/home",
    element: <VendorAdminHome />,
    label: "Home",
  },
  {
    path: "/always-on-channel",
    element: <AlwaysOnChannel />,
    label: "Always On Intelligence",
  },
  {
    path: "/public-data-briefings",
    element: <XFactorBriefings />,
    label: "Business Health Briefing",
  },
  {
    path: "/views-rendering",
    element: <TempViewsRendering />,
    label: "Temp Views Rendering",
  },
  {
    path: "/guidance-library",
    element: <SponsorTipsLibrary />,
    label: "Guidance Library",
  },
  {
    path: "/guidance-library/:slug",
    element: <SponsorTipDetail />,
    label: "Guidance Detail",
  },
  {
    path: "/ops",
    element: <Ops />,
    label: "Ops",
  },
  {
    path: "/sponsor-drilldown",
    element: <SponsorDrilldownPage />,
    label: "Sponsor Drilldown",
  },
  {
    path: "/easy-onboarding",
    element: <EasyOnboarding />,
    label: "Easy Onboarding",
  },
  {
    path: "/email-activity",
    element: <EmailActivity />,
    label: "Email Activity",
  },
  {
    path: "/relationship",
    element: <Relationship />,
    label: "Relationships",
  },
  {
    path: "/account-workspace/:id",
    element: <AccountWorkspace />,
    label: "Account Workspace",
  },
  {
    path: "/account-synopsis/:accountId",
    element: <AccountSynopsis />,
    label: "Account Synopsis",
  },
  {
    path: "/ops/create-assessment-template",
    element: <CreateAssessmentTemplate />,
    label: "Create Assessment Template",
  },
  {
    path: "/settings",
    element: <Settings />,
    label: "Settings",
  },
  {
    path: "/executive-staff",
    element: <ExecutiveStaff />,
    label: "Executive Staff",
  },
  {
    path: "/team-views",
    element: <TeamViewsPage />,
    label: "Team Views",
  },
  {
    path: "/coverage",
    element: <CoveragePage />,
    label: "Coverage",
  },
  {
    path: "/goals-milestones",
    element: <ComingSoon title="Goals & Milestones" />,
    label: "Goals & Milestones",
  },
  {
    path: "/leaderboard",
    element: <LeaderboardPage />,
    label: "Leaderboard",
  },
  {
    path: "/dashboard",
    element: <ComingSoon title="Dashboard" />,
    label: "Dashboard",
  },

  {
    path: "/HawkeyePage",
    element: <HawkeyePage />,
    label: "HawkeyePage",
  },
  {
    path: "/guidance/playbooks",
    element: <GuidancePlaybooks />,
    label: "Playbooks Hub",
  },
];

export default venderAdminRoutes;
